import * as Api from '@ViewModels';

/** Chart definitions for `POST opportunity/reporting/charts` (shared by fullscreen and Data Boards pages). */
export const OPPORTUNITY_REPORTING_CHARTS: Api.IOpportunityChartConfiguration[] = [
	{
		key: 'byStage',
		title: 'Opportunities by Stage',
		groupBy: 'Stage',
		aggregation: 'Sum',
		sortField: 'Label',
		sortAscending: true,
		visualizationType: 'Bar',
	},
	{
		key: 'byCloseDate',
		title: 'Opportunities by Close Date',
		groupBy: 'CloseDate',
		dateGranularity: 'Month',
		aggregation: 'Sum',
		sortField: 'Label',
		sortAscending: true,
		visualizationType: 'Line',
	},
	{
		key: 'byCreationDate',
		title: 'Opportunities Created Over Time',
		groupBy: 'CreationDate',
		dateGranularity: 'Month',
		aggregation: 'Sum',
		sortField: 'Label',
		sortAscending: true,
		visualizationType: 'Line',
	},
	{
		key: 'byTag',
		title: 'Deal Size by Tag',
		groupBy: 'Tag',
		aggregation: 'Sum',
		limit: 10,
		sortField: 'Value',
		sortAscending: false,
		visualizationType: 'Bar',
	},
	{
		key: 'dealSizeDistribution',
		title: 'Deal Size Distribution',
		groupBy: 'DealSizeRange',
		aggregation: 'Sum',
		sortField: 'Label',
		sortAscending: true,
		visualizationType: 'Bar',
	},
	{
		key: 'byOwner',
		title: 'Deal Size by Owner',
		groupBy: 'Owner',
		aggregation: 'Sum',
		limit: 10,
		sortField: 'Value',
		sortAscending: false,
		visualizationType: 'Bar',
	},
	{
		key: 'topCompanies',
		title: 'Top Companies by Deal Size',
		groupBy: 'Company',
		aggregation: 'Sum',
		limit: 10,
		sortField: 'Value',
		sortAscending: false,
		visualizationType: 'Bar',
	},
];
